import { DeleteScientificAreaType } from "../../../types/ScientificAreas";
import { del } from "../../../utils/axios-config";
import { SCIENTIFICAREAS } from "../../../utils/constants";

export const deleteScientificArea = async (data: DeleteScientificAreaType) => await del<DeleteScientificAreaType, boolean>(SCIENTIFICAREAS, data);